import { HintElement } from '../../types'

import { h } from 'preact'

const parseLinks = (text: string) => {
  const linkPattern = /\[(.+?)\]\((.+?)\)/g
  const parts = text.split(linkPattern)
  const nodes = parts.map((part, index) => {
    if (index % 3 === 0) {
      return part
    } else if (index % 3 === 1) {
      return (
        <a href={parts[index + 1]} target="_blank" rel="noreferrer">
          {part}
        </a>
      )
    } else {
      return null
    }
  })
  return nodes.filter((node) => node !== null)
}

export const HintElementView = (props: { elem: HintElement }) => {
  const el = props.elem
  switch (el.type) {
    case 'text': {
      const nodes = parseLinks(el.value)
      return <p className="hint_element_text">{nodes}</p>
    }

    case 'image': {
      const src = `./img/${el.value}`
      return <img src={src} />
    }
  }
}
